import { render, staticRenderFns } from "./product-setting.vue?vue&type=template&id=278a4518&scoped=true&"
import script from "./product-setting.vue?vue&type=script&lang=js&"
export * from "./product-setting.vue?vue&type=script&lang=js&"
import style0 from "./product-setting.vue?vue&type=style&index=0&id=278a4518&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a4518",
  null
  
)

export default component.exports